import React from 'react';

export const AdultsOnlyPosition69Icon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2573_2106)">
        <path
          d="M23.74 40.48C26.4131 40.48 28.58 38.3131 28.58 35.64C28.58 32.967 26.4131 30.8 23.74 30.8C21.067 30.8 18.9 32.967 18.9 35.64C18.9 38.3131 21.067 40.48 23.74 40.48Z"
          fill="#FF6AA0"
        />
        <path
          d="M33.04 50.0801C32.58 50.1001 32.14 50.0801 31.68 50.0801C29.08 49.9201 26.56 49.8001 24.08 48.5601C21.3 47.2001 19.52 44.8601 18.86 44.4001C18.54 44.1401 18.52 44.0401 17.96 43.9401C13.42 44.2601 9.22003 47.1201 4.40003 48.8601C4.04002 49.0201 3.66003 48.5601 3.90003 48.2401C7.96002 42.8401 14.76 34.5601 22.46 38.2001C24.72 39.4001 25.58 40.7201 27.4 41.4601C28.76 42.0001 30.6 41.9801 32.14 42.1401C32.24 42.1401 32.36 42.1401 32.46 42.1401C31.4 44.7401 31.34 47.5801 33.04 50.0601V50.0801Z"
          fill="#00A6ED"
        />
        <path
          d="M51.34 45.6599C51.28 45.8999 51.1 46.0999 50.9 46.1999C48.84 47.1999 46.72 47.9799 44.58 48.5599C43.62 48.1999 42.72 47.8399 41.96 47.4399C40.7 46.8599 41.04 46.1999 41.24 45.9799C41.72 45.3399 43 44.3199 43.96 43.8199C44.22 43.6999 44.48 43.5399 44.72 43.3799C46.72 43.6799 48.72 44.0799 50.72 44.5999C51.18 44.7199 51.46 45.1999 51.34 45.6599Z"
          fill="#00A6ED"
        />
        <path
          d="M55.0201 43.42C57.6931 43.42 59.8601 41.253 59.8601 38.58C59.8601 35.9069 57.6931 33.74 55.0201 33.74C52.347 33.74 50.1801 35.9069 50.1801 38.58C50.1801 41.253 52.347 43.42 55.0201 43.42Z"
          fill="#00A6ED"
        />
        <path
          d="M46.6 49.5399C44.88 49.0199 43.26 48.6399 41.9 48.0399C40.54 47.4999 39.74 46.6799 39.94 46.1999C40.6 44.9999 42.06 43.6999 43.48 42.9399C47.18 41.1599 49.58 36.3599 46.04 33.0999C41.52 29.4999 35.22 30.1799 30.18 31.5999C29.82 31.6999 29.76 32.2399 30.1 32.3999C32.88 34.1199 36.04 35.1399 38.54 36.5999C36.52 37.8599 34.78 39.4599 33.58 41.8799C31.28 45.9799 33.26 51.6799 38.1 52.5999C41.14 53.2599 44.2 52.4999 46.76 51.1399C46.94 51.0399 47.1 50.8599 47.16 50.6399C47.3 50.1799 47.04 49.6999 46.58 49.5599L46.6 49.5399ZM40.76 38.2199C40.76 38.2199 40.7 38.1799 40.64 38.1199C40.68 38.1599 40.72 38.1799 40.76 38.2199Z"
          fill="#FF6AA0"
        />
      </g>
      <defs>
        <clipPath id="clip0_2573_2106">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
